// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L_85u","footer":"styles_footer__VmN4l","passCodeTooltip":"styles_passCodeTooltip__v-_2d"};